import { Grid } from '@mui/material';
import * as React from 'react';
import { Event } from '../types/search.types';
import { HistoricoHeader } from './HistoricoHeader';
import { SearchEventCard } from './SearchEventCard';

interface SearchEventListProps {
  events: Event[];
}

export const SearchEventList: React.FC<SearchEventListProps> = ({ events }) => {
  const completedEvents = events.filter((event) => event.concluido === 1);

  return (
    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
      <HistoricoHeader />
      {completedEvents.map((event) => (
        <Grid item xs={12} sm={6} md={6} key={event.id}>
          <SearchEventCard event={event} />
        </Grid>
      ))}
    </Grid>
  );
};
